module.exports = __webpack_public_path__ + "img/CaptainMarvel_A_01.d14cb85b.png";